import { Subject } from "rxjs";
import { MoovStepConfigurationDTO } from "../DTO/moovStepConfigurationDTO";
import { AllocationProtocolOverride } from "./allocationProtocolOverride";
import { FilterProtocolOverride } from "./filterProtocolOverride";
import { MoovStep } from "./moovStep";
import { MoovStepPremierServiceConfiguration } from "./moovStepPremierServiceConfiguration";
import { ValidationProtocolOverride } from "./validationProtocolOverride";

export class MoovStepConfiguration{
    public id?:number;
    public delayBy?:number;
    public approveBy?:number;
    public outputOverrides!: OutputOverride[];
    public filterOverrides!: FilterOverride[];
    public allocationOverrides!: AllocationOverride[];
    public validationOverrides!: ValidationOverride[];
    public parameterOptionId?:number;
    public parameters!: ConfigurationParameter[];
    public moovConfigurationId!:number;
    public moovStepId!:number;
    public moovStep?:MoovStep;
    public premierServiceConfigurations!: MoovStepPremierServiceConfiguration[];
    public skipIfNoData:boolean=false;
    public skipAlways:boolean=false;

    public presetChangedSubject = new Subject<number>()
    
    constructor(){
        this.outputOverrides=[];
        this.filterOverrides=[];
        this.validationOverrides=[];
        this.allocationOverrides=[];
        this.parameters=[];
        this.premierServiceConfigurations=[];
    }

    public static mapFromDTO(param:MoovStepConfigurationDTO):MoovStepConfiguration{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MoovStepConfiguration();
        try
        {
            obj.id = param.id;
            obj.delayBy = param.delayBy;
            obj.approveBy = param.approveBy;
            if(param.outputOverrides){
                let ooArray:any[] = JSON.parse(param.outputOverrides);
                ooArray.forEach(oo=>{
                    let outputOverride = new OutputOverride();
                    obj.outputOverrides.push(Object.assign(outputOverride,oo));
                });
            }
            obj.parameterOptionId = param.parameterOptionId;
            if(param.parameters) {
                let cpArray:any[] = JSON.parse(param.parameters);
                cpArray.forEach(cp=>{
                    let configurationParameter = new ConfigurationParameter();
                    obj.parameters.push(Object.assign(configurationParameter,cp));
                });
            }
            if(param.filterOverrides){
                let foArray:any[] = JSON.parse(param.filterOverrides);
                foArray.forEach(fo=>{
                    let fpo = new FilterProtocolOverride();
                    obj.filterOverrides.push(Object.assign(fpo,fo));
                });
            }
            if(param.allocationOverrides){
                let aoArray:any[] = JSON.parse(param.allocationOverrides);
                aoArray.forEach(ao=>{
                    let apo = new AllocationProtocolOverride();
                    obj.allocationOverrides.push(Object.assign(apo,ao));
                });
            }
            if(param.validationOverrides){
                let voArray:any[] = JSON.parse(param.validationOverrides);
                voArray.forEach(vo=>{
                    let vpo = new ValidationProtocolOverride();
                    obj.validationOverrides.push(Object.assign(vpo,vo));
                });
            }
            obj.moovConfigurationId = param.moovConfigurationId;
            obj.moovStepId = param.moovStepId;
            if(param.premierServiceConfigurations) obj.premierServiceConfigurations = param.premierServiceConfigurations.map(psc=>MoovStepPremierServiceConfiguration.mapFromDTO(psc));
            obj.skipIfNoData = param.skipIfNoData;
            obj.skipAlways = param.skipAlways;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:MoovStepConfiguration):MoovStepConfigurationDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MoovStepConfigurationDTO();
        try
        {
            dto.id = param.id;
            dto.delayBy = param.delayBy;
            dto.approveBy = param.approveBy;
            if(param.outputOverrides?.length>0) dto.outputOverrides = JSON.stringify(param.outputOverrides);
            dto.parameterOptionId = param.parameterOptionId;
            if(param.parameters?.length>0) dto.parameters = JSON.stringify(param.parameters);
            if(param.filterOverrides?.length>0) dto.filterOverrides = JSON.stringify(param.filterOverrides);
            if(param.allocationOverrides?.length>0) dto.allocationOverrides = JSON.stringify(param.allocationOverrides);
            if(param.validationOverrides?.length>0) dto.validationOverrides = JSON.stringify(param.validationOverrides);
            dto.moovConfigurationId = param.moovConfigurationId;
            dto.moovStepId = param.moovStep!.id;
            dto.premierServiceConfigurations = param.premierServiceConfigurations.map(psc=>MoovStepPremierServiceConfiguration.mapToDTO(psc));
            dto.skipIfNoData = param.skipIfNoData;
            dto.skipAlways = param.skipAlways;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    public raisePresetChanged(moovStepId:number){
        this.presetChangedSubject.next(moovStepId);
    }
}

export class OutputOverride{
    public name!:string;
    public index!:number;
    public value!:string;
    public type!: number; //0=text, 1=metadata, 2=transformation override

    constructor(){
        this.type=0;
    }
}

export class FilterOverride{
    public protocolId!:number;
    public value!:string;
}

export class ValidationOverride{
    public protocolId!:number;
    public value!:string;
}

export class AllocationOverride{
    public protocolId!:number;
    public value!:string;
}

export class ConfigurationParameter{
    public name!:string;
    public value!:string;
}